import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Injectable } from "@angular/core";
export declare type MatSnackBarColorName = 'snackbar-success' | 'snackbar-info' | 'snackbar-warning' | 'snackbar-danger';
@Injectable({ providedIn: "root" })
export class NotificationService {
  /**
   *
   */
  constructor(private snackBar: MatSnackBar, private translate: TranslateService) {

  }

  showNotification(text?, colorName?: MatSnackBarColorName, placementFrom?: MatSnackBarVerticalPosition, placementAlign?: MatSnackBarHorizontalPosition, duration?: number) {
    this.snackBar.open(text, "", {
      duration: duration || 3000,
      verticalPosition: placementFrom || 'bottom',
      horizontalPosition: placementAlign || 'center',
      panelClass: colorName || 'snackbar-success',
    });
  }
  showSuccessAdded() {
    this.showNotification(this.translate.instant('RECORD_ADDED_SUCCESSFULLY'), 'snackbar-success');
  }
  showSuccessUpdate() {
    this.showNotification(this.translate.instant('RECORD_UPDATED_SUCCESSFULLY'), 'snackbar-success');
  }
  showSuccessDelete() {
    this.showNotification(this.translate.instant('RECORD_DELETE_SUCCESSFULLY'), 'snackbar-danger');
  }
}
